export type Nil = '@imddata/nil';
export const nil: Nil = '@imddata/nil';
